import { useState } from 'react'
import { Download } from 'lucide-react'
import { sightmapYaml } from '../guidance/polish/sightmap/emit'
import type { SightmapDoc } from '../guidance/polish/sightmap/schema'

export function SightmapYaml({ doc }: { doc: SightmapDoc }) {
  const [open, setOpen] = useState(false)
  return <details className="site-map__technical" onToggle={event => setOpen(event.currentTarget.open)}>
    <summary>Sightmap YAML</summary>
    {open && <pre>{sightmapYaml(doc)}</pre>}
  </details>
}

export function SightmapDownload({ doc }: { doc?: SightmapDoc }) {
  return <button className="site-map__download" type="button" title="Download sightmap as YAML" disabled={!doc} onClick={() => {
    if (!doc) return
    const url = URL.createObjectURL(new Blob([sightmapYaml(doc)], { type: 'application/yaml;charset=utf-8' }))
    const anchor = document.createElement('a')
    anchor.href = url
    anchor.download = 'sightmap.yaml'
    anchor.click()
    setTimeout(() => URL.revokeObjectURL(url), 0)
  }}><Download size={14} aria-hidden="true" />Download YAML</button>
}
